import api from './api';

export const locationManagementService = {
  // Get all locations for a specific trial centre with pagination
  async getLocationManagement(trialCentreId, params = {}) {
    try {
      const defaultParams = {
        trial_centre_id: trialCentreId,
        page: 1,
        limit: 10,
        ...params
      };
      const response = await api.get('/location-management', { 
        params: defaultParams
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch location management data');
    }
  },

  // Get location management by ID
  async getLocationManagementById(id) {
    try {
      const response = await api.get(`/location-management/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch location management details');
    }
  },

  // Create new location for trial centre
  async createLocationManagement(locationData) {
    try {
      const response = await api.post('/location-management', locationData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to create location');
    }
  },

  // Update location management
  async updateLocationManagement(id, locationData) {
    try {
      const response = await api.put(`/location-management/${id}`, locationData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update location');
    }
  },

  // Delete location management
  async deleteLocationManagement(id) {
    try {
      const response = await api.delete(`/location-management/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete location');
    }
  },

  // Get location management statistics
  async getLocationManagementStats(trialCentreId) {
    try {
      const response = await api.get(`/location-management/stats`, {
        params: { trial_centre_id: trialCentreId }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch location management statistics');
    }
  },

  // Export location management data
  async exportLocationManagement(trialCentreId, format = 'excel') {
    try {
      const response = await api.get(`/location-management/export/${format}`, {
        params: { trial_centre_id: trialCentreId },
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to export location management data');
    }
  },

  // Create location assignment
  async createLocationAssignment(locationId, assignmentData) {
    try {
      const response = await api.post(`/location-management/${locationId}/assignments`, assignmentData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to create location assignment');
    }
  },

  // Get location assignments
  async getLocationAssignments(locationId) {
    try {
      const response = await api.get(`/location-management/${locationId}/assignments`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch location assignments');
    }
  },

  // Update location assignment
  async updateLocationAssignment(locationId, assignmentId, assignmentData) {
    try {
      const response = await api.put(`/location-management/${locationId}/assignments/${assignmentId}`, assignmentData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update location assignment');
    }
  },

  // Delete location assignment
  async deleteLocationAssignment(locationId, assignmentId) {
    try {
      const response = await api.delete(`/location-management/${locationId}/assignments/${assignmentId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete location assignment');
    }
  }
};
